// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","167":"detail","177":"home","443":"about","505":"case","631":"contact","834":"partner"}[chunkId] + "." + {"18":"11f37eb9","167":"e0e3401c","177":"2dcbfe6e","443":"9a988842","505":"c77c31ee","631":"6c69f035","834":"cdd5bb61"}[chunkId] + ".js";
};